const { withNormalization } = require('./utils/normalization');
const { setRuleValidator } = require('./utils/validation');

module.exports = withNormalization({
  normalize: rule => ({
    ...rule,
    elements: new Set(rule.elements)
  }),

  test({ params, rule }) {
    if (!params.hasOwnProperty(rule.arrayName)) {
      return false
    }

    const paramsArray = params[rule.arrayName];
    if (!Array.isArray(paramsArray)) {
      return false
    }

    const set = new Set(paramsArray);
    return set.size === rule.elements.size && [...set].every(item => rule.elements.has(item))
  },

  validate: setRuleValidator
});
